import * as DOMHelpers from './DOMHelpers';

function display(divId)
{
    let div = document.querySelector(divId);
    //console.log(divId);
    if(div) {
        div.classList.remove('d-none');
    }
}

function hide(divId) {
    let div = document.querySelector(divId);
    //console.log('leave: ' + divId);
    if(div) {
        div.classList.add('d-none');
    }
}

function getTargetId(target)
{
    let button = DOMHelpers.getMatched(target, '[data-trigger="hover-display"]');

    if(button !== null) {
        return button.getAttribute('data-target');
    }

    return null;
}

// zavadeci skript
document.addEventListener("DOMContentLoaded", function() {
    document.body.addEventListener('mouseover', function(e) {
        let target = e.target || e.srcElement;
        display(getTargetId(target));
    });

    document.body.addEventListener('mouseout', function(e) {
        let target = e.target || e.srcElement;
        hide(getTargetId(target));
    });
});
